module.exports = __webpack_public_path__ + "static/media/engine.a0c3e97c.jpg";